module.exports = __webpack_public_path__ + "static/media/logo-header-white.47c42481.svg";